export default () => ({
  message: {
    text: '',
    color: '',
  },
})
